import { RobotLoveIcon } from './RobotLoveIcon';

/**
 * author: Colton Wiscombe
 * id 2EFA6B95-27BD-4A52-90AF-991A3574FD2C
 * name robot-love
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-love.svg
 * tags
 */
export const EmojiRobotLoveIcon = RobotLoveIcon;
export default EmojiRobotLoveIcon